(() => {

  const fixKlaviyoWidget = () => {
    let widget = document.querySelector('.needsclick');
    if (!widget) return;
    widget.style.zIndex = 1;
  }

  const fixLiveChatWidget = () => {
    let widget = document.querySelector('#bc-livechat-container');
    let widgetFrame = document.querySelector('#bc-frame-container');
    if (!widget) return;
    widget.style.zIndex = 4;
    if (!widgetFrame) return;
    widgetFrame.style.zIndex = 4;
  }

  const fixReviewLinks = () => {
    let reviewTarget = '#stamped-main-widget';
    document.querySelectorAll("a[is='review-link']").forEach(link => {
      const href = link.href;
      // replace everything between # and ?
      link.href = href.replace(/(#[^?]+)/, reviewTarget);
    })
  }

  function init() {
    fixReviewLinks();
    setTimeout(() => {
      fixKlaviyoWidget();
      fixLiveChatWidget();
    }, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init();
    });
  } else {
    init();
  }

})();
